var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.mode === 'font-class')?_c('span',{class:['iconhuice', _vm.fontClassName],style:(_vm.fontClassStyle)}):(_vm.mode === 'svg')?_c('svg',{staticClass:"icon",style:(_vm.svgStyle),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.svgHref}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }